import { useSelector } from 'react-redux';

import { entityNameSelector } from '!core/redux';

import { TypographyStyled } from './TrlUserInfo.styles';

export const TrlUserInfo = () => {
  const entityName = useSelector(entityNameSelector);

  return <TypographyStyled>{entityName}</TypographyStyled>;
};
